const ELM_NAME = 'autoplay-video';

if (!customElements.get(ELM_NAME)) {
  class AutoplayVideo extends HTMLElement {
    /** @type {HTMLVideoElement | null} */
    video = null;
    /** @type {IntersectionObserver | null} */
    observer = null;
    /** @type {{ threshold: number }} */
    options = {
      threshold: 0.666,
    };

    connectedCallback() {
      const video = this.querySelector('video');
      const options = JSON.parse(this.dataset.options || '{}');

      this.options = {
        ...this.options,
        ...options,
      };

      if (video) {
        this.video = video;
        this.initialize();
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    observerCallback = (entries) => {
      entries.forEach((entry) => {
        const { target: video } = entry;

        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
        }
      });
    }

    initialize = () => {
      if (this.video && "IntersectionObserver" in window) {
        this.observer = new IntersectionObserver(this.observerCallback, {
          threshold: this.options.threshold,
        });

        this.observer.observe(this.video);
      } else if (this.video) {
        this.video.play();
      }
    }
  }

  window.AutoplayVideo = AutoplayVideo;
  customElements.define(ELM_NAME, AutoplayVideo);
}
